import * as bootstrap from 'bootstrap';
import $ from 'jquery';

import { v1BaseUrl } from './config.js';
import { renderLibraryRoute } from '/js/router.js';
import { escapeHtml } from '@shared/js/toasts.js';

// Submit the entered code to the API and update the modal UI with the result.
function redeem() {
	// UI
	$('#reAlert').addClass('d-none');

	$("#rmCancelBtn").addClass('disabled');
	$('#codeInput').attr('disabled', true);
	$("#redeemBtn").addClass('d-none');
	$("#redeemBtnLoading").removeClass('d-none');

	let code = $("#codeInput").val().trim();

	let reqData = {
		"code": code
	};

        $.ajax({
                url: v1BaseUrl + "account/redeem",
                type: "post",
                svErrorMode: 'default',
                xhrFields: {
                        withCredentials: true
                  },
		dataType: 'json',
		data: reqData,
		success: function (data) {

			// UI
			$("#rmCancelBtn").removeClass('disabled');
			$('#codeInput').attr('disabled', false);
			$("#redeemBtn").removeClass('d-none');
			$("#redeemBtnLoading").addClass('d-none');

			if (data.success) {
				let showTitle = data.show.title;
				$("#codeInput").val("");
				dismissRedemptionModal();
				// Route through the router so the URL and cached view stay
				// in sync even when redeeming from a details or watch page.
				renderLibraryRoute('success', `Successfully redeemed "${escapeHtml(showTitle)}". It has been added to your vault.`);
			} else {
				$('#reAlert').removeClass('d-none');
				$('#reAlert').text(data.error || 'Oops! You\'ve entered an invalid code, please try again.');
				// Keep the entered code selected so a typo can be corrected
				// without retyping the whole thing.
				$('#codeInput').trigger('select');
			}

		},
		error: function () {

			// UI
			$("#rmCancelBtn").removeClass('disabled');
			$('#codeInput').attr('disabled', false);
			$("#redeemBtn").removeClass('d-none');
			$("#redeemBtnLoading").addClass('d-none');

			$('#reAlert').removeClass('d-none');
			$('#reAlert').text('Connection Failed! Please make sure you\'re connected to the internet.');
			$('#codeInput').trigger('select');

		}
	});

}

export function renderRedemptionModal() {
  // Create elements
  const modal = $('<div class="modal fade" tabindex="-1" id="redemptionModal" aria-modal="true" role="dialog"></div>');
  const modalDialog = $('<div class="modal-dialog"></div>');
  const modalContent = $('<div class="modal-content"></div>');
  const modalHeader = $('<div class="modal-header"></div>');
  const modalTitle = $('<h5 class="modal-title text-white">Redeem Show</h5>');
  const closeButton = $('<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>');
  const modalBody = $('<div class="modal-body"></div>');
  const alert = $('<div class="alert alert-danger d-none" role="alert" id="reAlert">An unknown error has occurred.</div>');
  const modalDescription = $('<p>Enter your show code to add the media to your account. Please note that once a code is redeemed, it cannot be used again or transferred to another account.</p>');
  // Wrapping the input in a form makes Enter submit the code — the footer
  // button is tied to it via the form attribute.
  const codeForm = $('<form id="redeemForm" novalidate></form>');
  const codeInput = $('<input class="form-control form-control-lg w-100 font-monospace text-uppercase" type="text" placeholder="ABCD1234" name="redemption_code" id="codeInput" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="go">');
  const modalFooter = $('<div class="modal-footer"></div>');
  const redeemButton = $('<button type="submit" form="redeemForm" class="btn btn-primary" id="redeemBtn">Redeem</button>');
  const redeemButtonLoading = $('<button class="btn btn-primary d-none" type="button" id="redeemBtnLoading" disabled=""><span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Redeeming...</button>');

  // Assemble the modal
  modalHeader.append(modalTitle, closeButton);
  codeForm.append(codeInput);
  modalBody.append(alert, modalDescription, codeForm);
  modalFooter.append(redeemButton, redeemButtonLoading);
  modalContent.append(modalHeader, modalBody, modalFooter);
  modalDialog.append(modalContent);
  modal.append(modalDialog);

  // Codes are uppercase alphanumeric — normalize as the user types.
  codeInput.on('input', function () {
	this.value = this.value.toUpperCase().replace(/\s/g, '');
  });

  // Submit (button click or Enter in the input) triggers redemption.
  codeForm.on('submit', function (event) {
	event.preventDefault();
	redeem();
  });

  // Focus the input as soon as the modal finishes opening.
  modal.on('shown.bs.modal', function () {
	codeInput.trigger('focus');
  });

  // Update the click event listener for the close button
  closeButton.on('click', function () {
	dismissRedemptionModal();
  });

  // Append the modal to the body
  $('body').append(modal);
}

export function dismissRedemptionModal() {
  const modalElement = document.getElementById('redemptionModal');
	const modalInstance = bootstrap.Modal.getInstance(modalElement);
	if (modalInstance) {
	  modalInstance.hide();
	}
}
